import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";

import moment from "moment";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

import Filter from "./Filter/Filter";
import TotalCard from "./TotalCard/TotalCard";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import Menu from "./Menu/Menu";
import LedgerCard from "./LedgerCard";

const backend = await new Backend().init();

export default function Ledger(props) {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [ledger, setLedger] = useState([]);

  const [deposit, setDeposit] = useState(0);
  const [withdraw, setWithdraw] = useState(0);

  const [deposit_wallet, setDepositWallet] = useState(0);
  const [withdraw_wallet, setWithdrawWallet] = useState(0);

  const [credit, setCredit] = useState(0);
  const [pl, setPl] = useState(0);

  const [nse_cash, setNseCash] = useState(0);

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadLedger();
  }, []);

  const loadLedger = () => {
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      ledger_id: localStorage.getItem("id"),
    };

    backend.load_ledger(data).then((r) => {
      setLoading(false);

      if (r.error === "False") {
        setLedger(r.ledger);
        setWithdraw(r.withdraw);
        setDeposit(r.deposit);

        setWithdrawWallet(r.withdraw_wallet);
        setDepositWallet(r.deposit_wallet);

        setCredit(r.credit);
        setPl(r.net_pl);
        setNseCash(r.nse_cash);
      } else {
        toast.error(r.message);
      }
    });
  };

  const loadLedgerDate = (a, b) => {
    setDate_Start(a);
    setDate_End(b);

    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      start: a ?? date_start,
      end: b ?? date_end,
      ledger_id: localStorage.getItem("id"),
    };

    backend.load_ledger(data).then((r) => {
      setLoading(false);

      if (r.error === "False") {
        setLedger(r.ledger);
        setWithdraw(r.withdraw);
        setDeposit(r.deposit);

        setWithdrawWallet(r.withdraw_wallet);
        setDepositWallet(r.deposit_wallet);

        setCredit(r.credit);
        setPl(r.net_pl);
        setNseCash(r.nse_cash);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div className="w-full">
      <Filter ledger={loadLedgerDate} />

      <TotalCard
        nse_cash={nse_cash}
        pl={pl}
        deposit_wallet={deposit_wallet}
        withdraw_wallet={withdraw_wallet}
        deposit={deposit}
        credit={credit}
        withdraw={withdraw}
      />

      <Menu />

      {/* LEDGER LIST SECTION */}
      <div
        key={ledger}
        className="flex flex-col"
        style={{ height: windowSize[1] - 265 }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 265} />
          </div>
        ) : ledger.length > 0 ? (
          <div
            className="overflow-y-scroll"
            style={{ height: windowSize[1] - 265 }}
          >
            {ledger.map((item) => (
              <LedgerCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 265}
            title={"Nothing here"}
            subtext={"No Ledger Found."}
          />
        )}
      </div>
    </div>
  );
}
